import React from 'react';
import PropTypes from 'prop-types'

import locationIcon from './location.svg';

/**
 * The TicketViewLocation component.
 *
 * @constructor
 */
export class TicketViewLocation extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const locationData = this.props.location || {};

    return (
      <div className="ticket-view-location">
        <div className="media-object">
          <div className="media-object-section icon-wrapper">
            <img className="icon" src={locationIcon} alt="location"/>
          </div>
          <div className="media-object-section">
            <div className="schedule-data">
              <h3>Location</h3>

              {(locationData) ? (
                <div>
                  <div>{locationData.address || locationData.line1}</div>

                  {(!locationData.address && locationData.line2) && (
                    <div>{locationData.line2}</div>
                  )}

                  <div>
                    <span className="inline-text">
                      {locationData.city}{(locationData.city) && (<span>,</span>)}
                    </span>
                    <span className="inline-text">{locationData.state}</span>
                    <span className="inline-text">{locationData.zip}</span>
                  </div>
                </div>
              ) : (
                <p>No location information provided</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TicketViewLocation.propTypes = {
  location: PropTypes.shape({
    address: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string
  }).isRequired
};

export default TicketViewLocation;



// WEBPACK FOOTER //
// ./src/components/ticket/ticketViewLocation/TicketViewLocation.js